import { FetchProductsResponse } from "./productsApi"
import { GroupItem, ProductItem, ProductTableRow } from "./productsTypes"

export function transformProductsData(data: FetchProductsResponse): ProductTableRow[] {
    return data.productGroups.flatMap((group) => {
        const groupItem: GroupItem = {
            type: "group",
            id: group.id,
            name: group.name,
            price: undefined,
            isActive: undefined,
            marketingDetails: undefined,
            productPhoto: undefined,
        }

        const products = group.products.map<ProductItem>((product) => ({
            type: "product",
            groupId: group.id,
            ...product,
        }))

        return [groupItem, ...products]
    })
}
